<template>
	<div class="row">
		<div class="col-sm-6 col-xs-12">
			<sBox title="GRID ENFGESTOR">
				<div slot="tools">
					<aBtn
						action="private-save-users"
						@click="$refs.modal.open()"
						text="Usuário"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>
				<div slot="body">
					<sTable
						ref="tab"
						actionRead="private-read-users"
						actionDelete="private-delete-users"
						compData="ENFGESTOR"
						:labels="labels_enfgestor"
						:actions="['delete', 'edit']"
						:functions="functions"
						@edit="(data) => $refs.modal.open(data)"
					/>
				</div>
			</sBox>
		</div>
		<div class="col-sm-6 col-xs-12">
			<sBox title="GRID VIASST">
				<div slot="body">
					<sTable
						ref="tabSST"
						actionRead="private-read-users"
						actionDelete="private-delete-users"
						compData="sst-viamed"
						:labels="labels_viasst"
						:actions="['delete', 'edit']"
						@edit="(data) => $refs.modal.open(data)"
					/>
				</div>
			</sBox>
		</div>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal';
	import WBS from 'js/http';

	import pad from 'js/pad';

	export default {
		name: 'AppManagerUser',
		components: { sTable, sBox, modal, aBtn }, //
		data() {
			return {
				labels_viasst: [
					{ data: 'cod', label: '#' },
					{
						data: ['sst_id.nome', 'user'],
						label: 'Usuário',
						two: true,
					},
				],
				labels_enfgestor: [
					{ data: 'cod', label: '#' },
					{
						data: [['uid.nome', 'uid.sobrenome'], 'user'],
						label: 'Usuário',
						two: true,
					},
					{ data: 'uid.departamento', label: 'Depto' },
				],
				functions: [
					{
						cod: 'uid.departamento',
						fx: this.departamento,
					},
				],
				assets: {
					perfis: [],
					departamentos: [],
					tipos_de_clientes: [],
				},
			};
		},
		provide() {
			const assets = {};
			for (let item in this.assets) {
				Object.defineProperty(assets, item, {
					enumerable: true,
					get: () => this.assets[item],
				});
			}
			return {
				assets,
			};
		},
		methods: {
			perfil(val) {
				if (val.length != 0) {
					let perfil = this.$refs.modal.get_perfil(val);
					if (perfil == 404)
						return "<span class='label label-warning'>Perfil inexistente!</span>";
					else
						return `<span class='label label-success'>${perfil}</span>`;
				} else
					return "<span class='label label-warning'>Perfil inexistente!</span>";
			},
			departamento(val) {
				const indexDepto = this.assets.departamentos.findIndex(
					(item) => item.cod == val
				);
				const text =
					indexDepto != -1
						? this.assets.departamentos[indexDepto].titulo
						: '???';
				return `<span class='label label-default'>${text}</span>`;
			},
			identidade(val) {
				let name = String(val).toUpperCase();
				let Ini = name.split(' ');
				let inicias = '';
				Ini.forEach((item) => {
					if (item != '' && inicias.length <= 1) inicias += item[0];
				});
				return `<span class='users-inicias'>${inicias}</span> ${name}`;
			},
			filter(data) {
				// if(data != ''){
				// 	this.$refs.tab.setFilter()
				// }else this.$refs.tab.setFilter('')
				// this.$refs.tab.updateTable()
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Usuários', '']);
			WBS.send('protected-read-AssetsUsers', (resp) => {
				if (resp.status == 'success') {
					this.assets.perfis = resp.data.perfis;
					this.assets.departamentos = resp.data.departamentos;
					this.assets.tipos_de_clientes = resp.data.tipos_de_clientes;
				} else {
					toastr.error(resp.msgs[0]);
					console.log(resp);
				}
			});
		},
	};
</script>
<style>
	.users-inicias {
		font-size: 10px;
		float: left;
		background: #008d4c;
		color: #fff;
		width: 25px;
		height: 25px;
		border-radius: 25px;
		margin: -2px 5px -10px 0;
		text-align: center;
		line-height: 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/settings/users/index.vue